import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { FormFields } from '../../AccountForm.meta';

export const FundingSourceSelect = () => {
  const formBag = useFormContext<FormFields>();

  const {
    options: {
      DafOptions: { dafFundingSources },
    },
  } = useAccountFormContext();

  const dafFundingSourcesOptions = dafFundingSources.map(({ label, value }) => ({
    label,
    options: value,
  }));

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.FundingSourceAccountId"
      render={({ field: { value, onChange, ...field } }) => {
        return (
          <Select
            {...field}
            isPortal
            value={dafFundingSourcesOptions
              .map(({ options }) => options)
              .flat()
              .filter(option => option.value === value)}
            onChange={opt => {
              if (opt?.value) {
                onChange(opt?.value);
              }
            }}
            options={dafFundingSourcesOptions}
            label="Funding Source"
          />
        );
      }}
    />
  );
};
